import React from "react";

//Styles
import "./Questions.scss";

//Data
import { questionsExampleData } from "./exampleData";

//Components
import Accordion from "common-components/Accordion/Accordion";

//Assets
import { ReactComponent as BottomLineSvg } from "assets/how-it-works-bottom.svg";

function Questions() {
  return (
    <section className="page-landing questions">
      <h2>Common questions</h2>
      <div className="s-width-wrapper">
        <Accordion elementsList={questionsExampleData} />
      </div>
      <BottomLineSvg className="bottom-line" />
    </section>
  );
}

export default Questions;
